import ENV from "../env";

const getOrders = async ({
  orgId,
  orgIds,
  startTimestamp,
  endTimestamp,
  orderBy,
  orderDirection,
  limit,
  createdBy,
  excludeIncomplete,
  withMetadata = false,
}) => {
  try {
    const params = new URLSearchParams();

    if (orgId) params.append("orgId", orgId);
    if (Array.isArray(orgIds) && orgIds.length) params.append("orgIds", orgIds.join(","));
    if (startTimestamp) params.append("startTimestamp", startTimestamp);
    if (endTimestamp) params.append("endTimestamp", endTimestamp);
    if (orderBy) params.append("orderBy", orderBy);
    if (orderDirection) params.append("orderDirection", orderDirection);
    if (limit) params.append("limit", limit);
    if (createdBy) params.append("createdBy", createdBy);
    if (excludeIncomplete) params.append("excludeIncomplete", "true");
    // Orders change in real time. A unique request URL also avoids stale 304
    // responses returned by intermediary caches for a previously empty result.
    params.append("cacheBust", Date.now().toString());

    const url = `${ENV.firebaseApiUrl}/orders?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const responseBody = await response.text();
    let resData = null;

    try {
      resData = responseBody ? JSON.parse(responseBody) : null;
    } catch {
      // Cloud Functions can return a plain-text error before Express handles it.
    }

    if (!response.ok) {
      const errorMessage =
        resData?.message || resData?.error || responseBody || response.statusText || "Unknown error";
      console.error("Error while getting orders: " + errorMessage);
      throw new Error(`Error while getting orders: ${errorMessage}`);
    }

    const orders = resData?.orders || [];
    return withMetadata
      ? { orders, limitReached: Boolean(resData?.limitReached) }
      : orders;
  } catch (error) {
    console.error("Error while getting orders:", error);
    throw new Error(`Error while getting orders: ${error.message}`);
  }
};

export default getOrders;
